<template>
  <el-dialog title="预约须知" width="836px" class="reminder-dialog" :visible.sync="isShow" :close-on-click-modal="false">
    <div class="content-wrapper">
      <div class="content-tips" v-html="tips">
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" class="btn" :disabled="disabledReadBtn" @click="handleClickComfirm">
        <template v-if="disabledReadBtn">阅读({{readCountdown}}s)</template>
        <template v-else>我知道了</template>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "AntiepidemicReminder",
  props:["clickList", "term"],
  data() {
    return {
      readCountdown: 5, // 按钮倒计时
      isShow: false, // 是否显示弹框
      disabledReadBtn: true, // 置灰“阅读”按钮状态
      tips: ''
    };
  },
  watch:{
    
  },
  created() {},
  mounted() {
    // this.handleOpenDialog();
  },
  methods: {
    countdown() { // 开始倒计时
      this.disabledReadBtn = true;
      var time = 5;
      var _this = this;
      var timer = setInterval(function () {
        time -= 1;
        _this.readCountdown = time;
        if (time < 1) {
          clearInterval(timer);
          _this.disabledReadBtn = false;
        }
      }, 1000);
    },
    handleOpenDialog(desc) { // 打开弹框时触发
      // 把DOM字符串中的所有行内样式：font-size删掉
      // 原因是css外层className即使有!important也无法覆盖子标签的行内样式
      let oldTips = desc;
      this.tips = oldTips.replace(/font-size: .*?;/g, '');
      this.isShow = true;
      this.countdown();
    },
    handleClickComfirm() {
      this.isShow = false;
      if(this.clickList){
        this.clickList(this.term);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.reminder-dialog {
  ::v-deep .el-dialog {
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    .el-dialog__header {
      padding: 10px 14px 7px 20px;
      font-size: 18px;
      font-weight: 400;
      color: #0D1C28;
      line-height: 26px;
      border-bottom: 1px #EEE solid;
      .el-dialog__headerbtn {
        top: 14px;
        right: 14px;
      }
    }
    .el-dialog__body {
      padding: 0;
      font-size: 16px;
      font-weight: 400;
      color: #45484B;
      line-height: 22px;
      .content-wrapper {
        max-height: 542px;
        margin-top: 20px;
        margin-bottom: 20px;
        overflow-y: auto;
        .content-tips {
          margin-left: 20px;
          margin-right: 20px;
          span {
            color: #F13939;
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0 20px 20px;
      .btn {
        width: 94px;
        // height: 32px;
        padding: 4px 16px;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.85);
        background: $main-color;
        border-radius: 4px;
        border: unset;
        &.is-disabled{
          opacity: 0.5;
        }
        &:focus{
          outline: 2px solid #000;
        }
      }
    }
  }
}
</style>
